import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../../../core/network/http.service';
import { Observable } from 'rxjs';
import { eRegicardInfo } from '../model/eregicard.model';

@Injectable({
  providedIn: 'root'
})
export class eRegicardService extends HttpService  {

  constructor(public http: HttpClient) {
    super(http);
  }

  getRegistrationCard(cond: eRegicardInfo): Observable<eRegicardInfo> {
    return this.http.post<eRegicardInfo>(cond.eRegicardConnectUrl+'api/CardApi/getRegistrationCardData',cond);
  }

  saveRegicardInfo(cond: eRegicardInfo): Observable<eRegicardInfo> {
    return this.http.post<eRegicardInfo>(cond.eRegicardConnectUrl+`api/CardApi/requestForRegistrationCard`, cond);
 }

  cancelRegicardInfo(cond: eRegicardInfo): Observable<eRegicardInfo> {
    return this.http.post<eRegicardInfo>(cond.eRegicardConnectUrl+`api/CardApi/CancelRegistrationCard`, cond);
 }
}
